export type PurchaseInvoiceReportDocumentEntryType = 'HOA_DON_MUA_HANG_TRONG_NUOC' | 'HOA_DON_MUA_DICH_VU';

export interface PurchaseInvoiceReportDocumentEntryState {
  documentUuid: string;
  documentType: string;
  entryType: PurchaseInvoiceReportDocumentEntryType;
}

const DOCUMENT_ENTRY_TYPE_BY_CODE: Record<string, PurchaseInvoiceReportDocumentEntryType> = {
  HOA_DON_MUA_HANG_TRONG_NUOC: 'HOA_DON_MUA_HANG_TRONG_NUOC',
  HOA_DON_MUA_DICH_VU: 'HOA_DON_MUA_DICH_VU'
};

const readString = (value: unknown) => (typeof value === 'string' ? value.trim() : '');

export const resolvePurchaseInvoiceReportDocumentEntry = (
  row: MuaHangRecord
): PurchaseInvoiceReportDocumentEntryState | null => {
  if (!row || typeof row !== 'object') return null;

  const documentUuid = readString(row.document_uuid) || readString(row.uuid);
  const documentType = readString(row.document_type) || readString(row.ma_ct);
  const soCt = readString(row.so_ct) || readString(row.so_ct0) || readString(row.so_ct3);
  const entryType = DOCUMENT_ENTRY_TYPE_BY_CODE[documentType];

  if (!documentUuid || !documentType || !soCt || !entryType) {
    return null;
  }

  return {
    documentUuid,
    documentType,
    entryType
  };
};
